import React, { Component, useEffect } from "react";
import Layout from "./components/Layout";
import Main from "./Main";
import Error from "./Error";
import {
    BrowserRouter as Router,
    Routes,
    Route,
    Link,
} from "react-router-dom";
import "./App.css";
import Product from "./Product";
import { Helmet, HelmetProvider } from "react-helmet-async";
import AboutUs from "./AboutUs";
import Contacts from "./Contacts";
import Payment from "./Payment";
import { PayementSuccess } from "./components/Payment-success";
import { PayementFailure } from "./components/Payment-cancel";
import CheckoutPage from "./components/CheckoutPage";
import Terms from "./Terms";

class App extends Component {
    
    render() {
        return (
          <HelmetProvider>
            <div className="App">
              
            <Router basename="/">
            
                <Helmet>
                <meta charSet="utf-8" />
                <title>CG84</title>
                <meta name="description" content="Somas cg84" />
                
              </Helmet>
                    <Routes>
                      <Route exact path="/" element={<Layout lang="lv"></Layout>}>
                        <Route index element={<Main lang="lv"/>}></Route>
                        <Route path="product/:product" element={<Product lang="lv"/>}></Route>
                        <Route path="contacts" element={<Contacts lang="lv"></Contacts>}></Route>
                        <Route path="about-us" element={<AboutUs lang="lv"></AboutUs>}></Route>
                        <Route path="payment/success" element={<PayementSuccess lang="lv"></PayementSuccess>}></Route>
                        <Route path="payment/cancel" element={<PayementFailure lang="lv"></PayementFailure>}></Route>
                        <Route path="payment" element={<Payment lang="lv"></Payment>}></Route>
                        <Route path="checkout" element={<CheckoutPage lang="lv"></CheckoutPage>}></Route>
                        <Route path="terms" element={<Terms lang={"lv"}></Terms>}></Route>
                        <Route path="*" element={<Error lang="lv"></Error>}></Route>
                       
                      </Route>
                      <Route exact path="/lv" element={<Layout lang="lv"></Layout>}>
                        <Route index element={<Main lang="lv"/>}></Route>
                        <Route path="product/:product" element={<Product lang="lv"/>}></Route>
                        <Route path="contacts" element={<Contacts lang="lv"></Contacts>}></Route>
                        <Route path="about-us" element={<AboutUs lang="lv"></AboutUs>}></Route>
                        <Route path="payment/success" element={<PayementSuccess lang="lv"></PayementSuccess>}></Route>
                        <Route path="payment/cancel" element={<PayementFailure lang="lv"></PayementFailure>}></Route>
                        <Route path="payment" element={<Payment lang="lv"></Payment>}></Route>
                        <Route path="checkout" element={<CheckoutPage lang="lv"></CheckoutPage>}></Route>
                        <Route path="terms" element={<Terms lang={"lv"}></Terms>}></Route>
                        <Route path="*" element={<Error lang="lv"></Error>}></Route>
                      </Route>
                      <Route exact path="/en" element={<Layout lang="en"></Layout>}>
                        <Route index element={<Main lang="en"/>}></Route>
                        <Route path="product/:product" element={<Product lang="en"/>}></Route>
                        <Route path="contacts" element={<Contacts lang="en"></Contacts>}></Route>
                        <Route path="about-us" element={<AboutUs lang="en"></AboutUs>}></Route>
                        <Route path="payment/success" element={<PayementSuccess lang="en"></PayementSuccess>}></Route>
                        <Route path="payment/cancel" element={<PayementFailure lang="en"></PayementFailure>}></Route>
                        <Route path="payment" element={<Payment lang="en"></Payment>}></Route>
                        <Route path="checkout" element={<CheckoutPage lang="en"></CheckoutPage>}></Route>
                        <Route path="terms" element={<Terms lang={"en"}></Terms>}></Route>
                        <Route path="*" element={<Error lang="en"></Error>}></Route>
                      </Route>
                      <Route  exact path="/et" element={<Layout lang="et"></Layout>}>
                        <Route index element={<Main lang="et"/>}></Route>
                        <Route path="product/:product" element={<Product lang="et"/>}></Route>
                        <Route path="contacts" element={<Contacts lang="et"></Contacts>}></Route>
                        <Route path="about-us" element={<AboutUs lang="et"></AboutUs>}></Route>
                        <Route path="payment/success" element={<PayementSuccess lang="et"></PayementSuccess>}></Route>
                        <Route path="payment/cancel" element={<PayementFailure lang="et"></PayementFailure>}></Route>
                        <Route path="payment" element={<Payment lang="et"></Payment>}></Route>
                        <Route path="checkout" element={<CheckoutPage lang="et"></CheckoutPage>}></Route>
                        <Route path="terms" element={<Terms lang={"et"}></Terms>}></Route>
                        <Route path="*" element={<Error lang="et"></Error>}></Route>
                      </Route>
                      <Route  exact path="/lt" element={<Layout lang="lt"></Layout>}>
                        <Route index element={<Main lang="lt"/>}></Route>
                        <Route path="product/:product" element={<Product lang="lt"/>}></Route>
                        <Route path="contacts" element={<Contacts lang="lt"></Contacts>}></Route>
                        <Route path="about-us" element={<AboutUs lang="lt"></AboutUs>}></Route>
                        <Route path="payment/success" element={<PayementSuccess lang="lt"></PayementSuccess>}></Route>
                        <Route path="payment/cancel" element={<PayementFailure lang="lt"></PayementFailure>}></Route>
                        <Route path="checkout" element={<CheckoutPage lang="lt"></CheckoutPage>}></Route>
                        <Route path="payment" element={<Payment lang="lt"></Payment>}></Route>
                        <Route path="terms" element={<Terms lang={"lt"}></Terms>}></Route>
                        <Route path="*" element={<Error lang="lt"></Error>}></Route>
                      </Route>
                      <Route  exact path="/sv" element={<Layout lang="sv"></Layout>}>
                        <Route index element={<Main lang="sv"/>}></Route>
                        <Route path="product/:product" element={<Product lang="sv"/>}></Route>
                        <Route path="contacts" element={<Contacts lang="sv"></Contacts>}></Route>
                        <Route path="about-us" element={<AboutUs lang="sv"></AboutUs>}></Route>
                        <Route path="payment/success" element={<PayementSuccess lang="sv"></PayementSuccess>}></Route>
                        <Route path="payment/cancel" element={<PayementFailure lang="sv"></PayementFailure>}></Route>
                        <Route path="payment" element={<Payment lang="sv"></Payment>}></Route>
                        <Route path="checkout" element={<CheckoutPage lang="sv"></CheckoutPage>}></Route>
                        <Route path="terms" element={<Terms lang={"sv"}></Terms>}></Route>
                        <Route path="*" element={<Error lang="sv"></Error>}></Route>
                      </Route>

                      <Route  exact path="/fi" element={<Layout lang="fi"></Layout>}>
                        <Route index element={<Main lang="fi"/>}></Route>
                        <Route path="product/:product" element={<Product lang="fi"/>}></Route>
                        <Route path="contacts" element={<Contacts lang="fi"></Contacts>}></Route>
                        <Route path="about-us" element={<AboutUs lang="fi"></AboutUs>}></Route>
                        <Route path="payment/success" element={<PayementSuccess lang="fi"></PayementSuccess>}></Route>
                        <Route path="payment/cancel" element={<PayementFailure lang="fi"></PayementFailure>}></Route>
                        <Route path="payment" element={<Payment lang="fi"></Payment>}></Route>
                        <Route path="checkout" element={<CheckoutPage lang="fi"></CheckoutPage>}></Route>
                        <Route path="terms" element={<Terms lang={"fi"}></Terms>}></Route>
                        <Route path="*" element={<Error lang="fi"></Error>}></Route>
                      </Route>
                      
                    </Routes>
                    
            </Router>
            </div>
          </HelmetProvider>
            
        );
    }
}
 
export default App;